import React from "react";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import Traditional from "./themes/Traditional";
const GlobalStyles = createGlobalStyle `
  html, body {
    font-family: ${(props) => props.styles.fontFamily};
    background: ${(props) => props.styles.background};
    width: 100%;
    height: 100%;
  }

  .bcr-popover-closed {
      display: none;
  }
`;
const Container = styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const BCR = ({ children, containerClassname, containerStyle, theme = Traditional, hideContainer = false, }) => {
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(GlobalStyles, { styles: theme }),
        hideContainer ? (React.createElement(React.Fragment, null, children)) : (React.createElement(Container, { className: containerClassname, style: containerStyle }, children))));
};
export default BCR;
//# sourceMappingURL=BCR.js.map